import {
  AuthSession,
  ConfirmResetPasswordInput,
  ConfirmSignInInput,
  ConfirmUserAttributeInput,
  DeleteUserAttributesInput,
  FetchUserAttributesOutput,
  ResetPasswordInput,
  SendUserAttributeVerificationCodeInput,
  SignInInput,
  UpdateMFAPreferenceInput,
  UpdatePasswordInput,
  UpdateUserAttributesInput,
} from 'aws-amplify/auth';
import { Observable } from 'rxjs';

import { AuthSignInStep } from '../models/auth.model';

export abstract class AuthGateway {
  abstract fetchAuthSession(forceRefresh?: boolean): Observable<AuthSession>;
  abstract fetchMFAPreference(): Observable<'SMS' | 'TOTP' | 'EMAIL' | undefined>;
  abstract fetchUserAttributes(): Observable<FetchUserAttributesOutput>;
  abstract signIn(params: SignInInput): Observable<AuthSignInStep>;
  abstract confirmSignIn(params: ConfirmSignInInput): Observable<AuthSignInStep>;
  abstract signOut(): Observable<void>;
  abstract resetPassword(params: ResetPasswordInput): Observable<AuthSignInStep>;
  abstract confirmResetPassword(params: ConfirmResetPasswordInput): Observable<void>;
  abstract updatePassword(params: UpdatePasswordInput): Observable<void>;
  abstract updateUserAttribute(params: UpdateUserAttributesInput): Observable<never>;
  abstract verifyUserAttribute(params: SendUserAttributeVerificationCodeInput): Observable<never>;
  abstract verifyUserAttributeSubmit(params: ConfirmUserAttributeInput): Observable<never>;
  abstract deleteUserAttribute(params: DeleteUserAttributesInput): Observable<never>;
  abstract setPreferredMFA(params: UpdateMFAPreferenceInput): Observable<never>;
}
